<div>

  <!-- ===================== Toolbar (hidden on print) ===================== -->
  <div class="toolbar noPrint">
    <button
      *ngIf="updateStatus"
      class="noPrint"
      mat-raised-button
      color="primary"
      (click)="saveSubscriptionBarcodesDataEntry()">
      Save
    </button>

    <button
      [useExistingCss]="true"
      class="noPrint"
      mat-raised-button
      color="primary"
      printTitle="Label"
      printSectionId="print-section"
      ngxPrint>
      Print
    </button>

    <button mat-dialog-close class="btn noPrint">
      Close
    </button>
  </div>

  <!-- ===================== Printable section ===================== -->
  <div class="container mt-3" id="print-section">

    <!-- Select-all checkbox (currently disabled) -->
    <!--
    <div class="col" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;">
      <label>
        <input type="checkbox" [(ngModel)]="masterSelected" (change)="checkUncheckAll()"> All
      </label>
    </div>
    -->

    <div class="row wrapper" *ngFor="let item of filteredList">
      <div class="card" *ngIf="item['sub'] != 0">

        <!-- ---------- Header: logo + publisher details ---------- -->
        <div class="firstrow">

          <!-- Per-row checkbox (currently disabled) -->
          <!--
          <div class="col noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;">
            <label>
              <input type="checkbox" [(ngModel)]="item.isSelected" (change)="isAllSelected()"> {{ item.value }}
            </label>
          </div>
          <input type="checkbox" [(ngModel)]="data.selected" (change)="isAllSelected()">
          -->

          <div class="left">
            <img src="../../../assets/img/brand/red.png" alt="Brand logo" width="100">
          </div>

          <div class="right">
            <span>हिंदुस्थान प्रकाशन संस्था</span>
            <span>303, वडाळा उद्योग भवन, नायगाव क्राॅस रोड,</span>
            <span>वडाळा, मुंबई 400 031 दूरध्वनीः 9967570531</span>
          </div>
        </div>

        <div class="line"></div>

        <!-- ---------- Main content ---------- -->
        <div class="maincontent">

          <div class="vitaran">
            <span>वितरण माध्यम - {{ item['dis_mode'] }} - {{ item['dis_sub_mode'] }}</span>
            <span>अंक दिनांक : {{ isuuedate }}</span>
          </div>

          <div class="prati">
            <div></div>
            <div class="right">
              <span>प्रति,</span>
              <span>वितरण दिनांक : {{ dispatchdate }}</span>
            </div>
          </div>

          <div class="main">
            <div class="pratisankhya">
              <span class="f-w-600 fs-20">प्रति - </span>
              <span class="fs-20 fw-800">{{ item.prati }}</span>
            </div>

            <div class="name">
              <span class="fw-600">{{ item['issueSellerName'] }}</span>
              <span class="fs-16">{{ item['full_add'] }}</span>

              <!-- District / State line (currently disabled) -->
              <!--
              <span class="fs-16">{{ item['dis_dist'] }} - {{ item['dis_pin'] }} <br> {{ item['dis_state'] }}</span>
              -->

              <span class="fs-16">मोबाईल नं : {{ item['mob_no'] }}</span>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>